import {getLSLang, getUsuTipo, hasModule, hasPermissionTo, PERSMISOS, TIPOUSUARIO} from "../helpers";
import Clientes from '../views/clientes';
import CrearCliente from '../views/clientes/crearCliente';
import Prestamos from '../views/prestamos';
import Pagos from '../views/pagos';
import DetallesPrestamo from '../views/prestamos/detallesPrestamo';
import CrearPrestamo from '../views/prestamos/crearPrestamo';
import Ajustes from '../views/ajustes';
import Perfil from '../views/cuenta/perfil';
import Solicitudes from '../views/solicitud';
import Notificaciones from '../views/notificaciones';
import DetallesSolicitud from '../views/solicitud/DetallesSolicitud';
import Rutas from '../views/rutas';
import Feriados from '../views/feriados';
import Carteras from '../views/carteras';
import DetallesCartera from '../views/carteras/detalleCartera';
import Transacciones from "../views/reportes/Transacciones";
import IngresosVSGastos from "../views/reportes/IngresosVSGastos";
// import CuentasXcobrar from '../views/reportes/CuentasXcobrar';
//
import Inicio from '../views/inicio';
import Inicio2 from '../views/inicio/inicio2';
import Ayuda from '../views/ayuda';
import Map from '../views/Map';
//
import Cajas from '../views/cajas';
import CajaDetails from '../views/cajas/CajaDetails';
import Gastos from '../views/gastos';
import Ingresos from "../views/ingresos";

import Agentes from '../views/Agentes';
import Roles from '../views/roles';
import Plantillas from '../views/Plantillas';
import PlantillaCrear from '../views/Plantillas/crear';
import Autorizaciones from '../views/autorizaciones';

//,HowToRegOutlined
import {
    CallToActionOutlined,
    Dashboard,
    DescriptionOutlined,
    EventBusyOutlined,
    History,
    LocalAtmOutlined,
    MapOutlined,
    MessageOutlined,
    PeopleAltOutlined,
    PersonOutline,
    PlagiarismOutlined,
    ReceiptOutlined,
    SettingsOutlined,
    Tune
} from "@mui/icons-material"
import {AccountLockOutline, MapMarkerOutline, WalletBifoldOutline} from "mdi-material-ui";

//admin
import {lazy} from "react";
import {IRoutes} from "../redux/types/IRoutes";
// import Ingresos from "../views/reportes/Ingresos";
import SaldoPorAntiguedad from "../views/reportes/SaldoPorAntiguedad";
// import Egresos from "../views/reportes/Egresos";
import {MODULO_USUARIO} from "../helpers/CONSTANTES";
import Editar from "../views/appUsers/Editar";
import DetallesUsuario from "../views/appUsers/DetallesUsuario";
import CuadreDetalle from "../views/AdminCuadres/CuadreDetalle";
import CuadreInfo from "../views/AdminCuadres/CuadreInfo";
import HistorialCredito from "../views/HistorialCredito";

const AppUsers = lazy(() => import('../views/appUsers'));
 const AdminCuadres = lazy(() => import('../views/AdminCuadres'));
const UsosMultiples = lazy(() => import('../views/usosMultiples'));
const Enums = lazy(() => import('../views/enums'));
const Paises = lazy(() => import('../views/paises'));

const getRoutes = ()=>{
    let obj:IRoutes[] =  (
        [
            {
                path: "/perfil",
                navbarName: "Mi perfil",
                icon: PersonOutline,
                component: Perfil
            },
            {
                path: "/ayuda",
                navbarName: "Ayuda",
                icon: PersonOutline,
                component: Ayuda
            },
            {
                path: "/inicio",
                sidebarName: "inicio",
                navbarName: "inicio",
                icon: Dashboard,
                component: hasPermissionTo(PERSMISOS.dashboard) ? Inicio:Inicio2,
            },

            {
                path: "/solicitudes", //listado de solicitud de prestamo
                sidebarName: "solicitudes",
                navbarName: "solicitudes",
                icon: MessageOutlined,
                component: Solicitudes,
                restricted: (!hasPermissionTo(PERSMISOS.solicitudes) || !hasModule(MODULO_USUARIO.solicitudes)),
                nestedRoutes: [
                    {
                        path: "/solicitud/:id",
                        sidebarName: "solicitudes",
                        navbarName: "solicitudes",
                        component: DetallesSolicitud
                    },
                ]
            },
            {
                path: "/clientes", //lista de clientes
                sidebarName: "prestatarios",
                navbarName: "prestatarios",
                icon: PeopleAltOutlined,
                component: Clientes,
                restricted: !hasPermissionTo(PERSMISOS.clientes),
                nestedRoutes: [
                    {
                        path: "/cliente/:cliId", //detalles de clientes / actualizar
                        sidebarName: "detalles de clientes",
                        navbarName: "prestatario",
                        component: CrearCliente
                    },
                    {
                        path: "/crear/cliente", //Crear cliente
                        sidebarName: "Crear Cliente",
                        navbarName: "Crear Cliente",
                        component: CrearCliente
                    },
                ]
            },
            {
                path: "/prestamos",
                sidebarName: "prestamos",
                navbarName: "prestamos",
                component: Prestamos,
                icon:DescriptionOutlined,
                restricted: !hasPermissionTo(PERSMISOS.prestamos),
                nestedRoutes: [
                    {
                        path: "/prestamos/:clienteId",
                        sidebarName: "prestamos",
                        navbarName: "prestamos",
                        component: Prestamos
                    },
                    {
                        path: "/prestamo/:preId", //detalles de prestamo
                        sidebarName: "Table List",
                        navbarName: "Detalles de Prestamo",
                        component: DetallesPrestamo
                    },
                    {
                        path: "/crear/prestamo",
                        sidebarName: "Typography",
                        navbarName: "Crear Prestamo",
                        component: CrearPrestamo
                    },
                    {
                        path: "/reenganche/:preId",
                        sidebarName: "Typography",
                        navbarName: "Reenganche Prestamo",
                        component: CrearPrestamo
                    },
                    {
                        path: "/editar/prestamo/:preId", //Editar un prestamo
                        sidebarName: "Typography",
                        navbarName: "Editar Prestamo",
                        component: CrearPrestamo
                    }
                ]
            },
            ...(getLSLang("c") === "DO" ?
                [{
                    path: "/HistorialCredito",
                    sidebarName: "dataCredito",
                    navbarName: "dataCredito",
                    restricted: getUsuTipo() !== TIPOUSUARIO.admin ,
                    icon: History,
                    component: HistorialCredito,
                }]:[]),
            {
                path: "/pagos", //lista de pagos
                sidebarName: "pagos",
                navbarName: "pagos",
                icon: ReceiptOutlined,
                restricted: !hasPermissionTo(PERSMISOS.pagos),
                component: Pagos
            },
            {
                path: "/notificaciones",
                //sidebarName: "notificaciones",
                navbarName: "notificaciones",
               // icon: NotificationsActiveOutlined,
                component: Notificaciones
            },
            {
                sidebarName: "caja",
                icon: LocalAtmOutlined,
                nestedRoutes: [
                    {
                        path: "/cajas",
                        sidebarName: "cajas",
                        navbarName: "cajas",
                        restricted: (!hasPermissionTo(PERSMISOS.cajas) || !hasModule(MODULO_USUARIO.cajas)),
                        component: Cajas
                    },
                    {
                        path: "/caja/:cajId",
                        navbarName: "CajaDetails",
                        component: CajaDetails
                    },
                    {
                        path: "/gastos",
                        sidebarName: "gastos",
                        // icon: CashRemove,
                        navbarName: "gastos",
                        restricted: (!hasPermissionTo(PERSMISOS.gastos) || !hasModule(MODULO_USUARIO.gastos)),
                        component: Gastos
                    },

                    {
                        path: "/ingresos",
                        sidebarName: "Otros Ingresos",
                        // icon: CashCheck,
                        navbarName: "otrosIngresos",
                        restricted: (!hasPermissionTo(PERSMISOS.ingresos) || !hasModule(MODULO_USUARIO.ingresos)),
                        component: Ingresos
                    },
                ]

            },





            {
                path: "/carteras",
                sidebarName: "carteras",
                navbarName: "carteras",
                icon: WalletBifoldOutline,
                restricted: (!hasPermissionTo(PERSMISOS.carteras) || !hasModule(MODULO_USUARIO.carteras)),
                component: Carteras,
                nestedRoutes: [
                    {
                        path: "/cartera/:carId", //detalles de carteras
                        sidebarName: "Table List",
                        navbarName: "Detalles de carteras",
                        component: DetallesCartera
                    }
                ]
            },
            {
                path: "/mapa",
                sidebarName: "mapa",
                navbarName: "mapa",
                restricted: (!hasPermissionTo(PERSMISOS.mapa) || !hasModule(MODULO_USUARIO.geoMapa)),
                icon: MapOutlined,
                component: Map
            },

            {
                path: "/rutas",
                sidebarName: "rutas",
                navbarName: "rutas",
                icon: MapMarkerOutline,
                restricted: (!hasPermissionTo(PERSMISOS.rutas) || !hasModule(MODULO_USUARIO.rutas)),
                component: Rutas
            },


            {
                sidebarName: "reportes",
                icon: PlagiarismOutlined,
                navbarName: "reportes",
                // restricted: (!hasPermissionTo(PERSMISOS.re) || !hasModule(MODULO_USUARIO.cajas)),
                nestedRoutes: [
                    // {
                    //     path: "/cuentasXcobrar", //lista de pagos
                    //     sidebarName: "cuentasXcobrar",
                    //     navbarName: "cuentasXcobrar",
                    //     restricted: !hasPermissionTo(PERSMISOS.pagos),
                    //     component: CuentasXcobrar
                    // },
                    // {
                    //     path: "/ingresos", //lista de pagos
                    //     sidebarName: "ingresos",
                    //     navbarName: "ingresos",
                    //     restricted: !hasPermissionTo(PERSMISOS.reportesIngresos),
                    //     component: Ingresos
                    // },
                    // {
                    //     path: "/egresos",
                    //     sidebarName: "egresos",
                    //     navbarName: "egresos",
                    //     restricted: !hasPermissionTo(PERSMISOS.reportesEgresos),
                    //     component: Egresos
                    // },
                    {
                        path: "/transacciones",
                        sidebarName: "transacciones",
                        navbarName: "transacciones",
                        // restricted: !hasPermissionTo(PERSMISOS.reportesEgresos),
                        component: Transacciones
                    },
                    {
                        path: "/ingresosVSGastos",
                        sidebarName: "ingresosVSGastos",
                        navbarName: "ingresosVSGastos",
                        restricted: !hasPermissionTo(PERSMISOS.reportesIngresos) || !hasPermissionTo(PERSMISOS.reportesEgresos),
                        component: IngresosVSGastos
                    },
                    {
                        path: "/saldoPorAntiguedad",
                        sidebarName: "saldoPorAntiguedad",
                        navbarName: "saldoPorAntiguedad",
                        restricted: !hasPermissionTo(PERSMISOS.reportesAntiguedad),
                        component: SaldoPorAntiguedad
                    },
                ]
            },

            {
                sidebarName: "configuracion",
                icon: SettingsOutlined,
                nestedRoutes:[
                    ...(getUsuTipo() === TIPOUSUARIO.titular || getUsuTipo() === TIPOUSUARIO.admin ?
                            [
                                {
                                    path: "/ajustes",
                                    sidebarName: "empresa",
                                    navbarName: "empresa",
                                    icon: SettingsOutlined,
                                    component: Ajustes
                                }
                            ] : []
                    ),
                    {
                        path: "/plantillas",
                        sidebarName: "plantillas",
                        navbarName: "plantillas",
                        icon: CallToActionOutlined,
                        component: Plantillas,
                        //  nuevo: true,
                        restricted: (!hasPermissionTo(PERSMISOS.plantillas) || !hasModule(MODULO_USUARIO.plantillas)),
                        nestedRoutes: [
                            {
                                path: "/crear/plantilla",
                                component: PlantillaCrear
                            },
                            {
                                path: "/editar/plantilla/:plaId",
                                component: PlantillaCrear
                            }
                        ]
                    },
                    {
                        path: "/feriados",
                        sidebarName: "diasFeriados",
                        navbarName: "diasFeriados",
                        icon: EventBusyOutlined,
                        restricted: !hasPermissionTo(PERSMISOS.feriado),
                        nuevo: false,
                        component: Feriados
                    },
                ]
            },


            ...(getUsuTipo() === TIPOUSUARIO.titular || getUsuTipo() === TIPOUSUARIO.admin ?
                    [
                        {
                            sidebarName: "seguridad",
                            navbarName: "seguridad",
                            icon: AccountLockOutline,
                            nestedRoutes: [
                                {
                                    path: "/agentes",
                                    sidebarName: "agentes",
                                    navbarName: "agentes",
                                    restricted: !hasModule(MODULO_USUARIO.cajas),
                                    component: Agentes
                                },
                                {
                                    path: "/roles",
                                    sidebarName: "rolesPermisos",
                                    restricted: !hasModule(MODULO_USUARIO.cajas),
                                    navbarName: "rolesPermisos",
                                    component: Roles
                                },
                                {
                                    path: "/autorizaciones",
                                    sidebarName: "autorizaciones",
                                    navbarName: "autorizaciones",
                                    nuevo: false,
                                    component: Autorizaciones
                                }

                            ]
                        }
                    ] : []
            ),

            ...(getUsuTipo() === TIPOUSUARIO.admin ?
                    [{
                        sidebarName: "admin",
                        navbarName: "admin",
                        icon: Tune,
                        nestedRoutes: [
                            {
                                path: "/appUsers",
                                sidebarName: "companias",
                                navbarName: "companias",
                                component: AppUsers,
                                nestedRoutes:[
                                    {
                                        path: "/appUsers/:usuId",
                                        // sidebarName: "usuario",
                                        navbarName: "companias",
                                        component: AppUsers
                                    },
                                    {
                                        path: "/appUserDetails/:usuId",
                                        // sidebarName: "usuario",
                                        navbarName: "companias",
                                        component: DetallesUsuario
                                    },
                                    {
                                        path: "/appUser/:usuId",
                                        // sidebarName: "usuario",
                                        navbarName: "companias",
                                        component: Editar
                                    },
                                ]
                            },

                            {
                                path: "/AdminCuadres",
                                sidebarName: "cuadres",
                                navbarName: "cuadres",
                                component: AdminCuadres,
                                nestedRoutes: [
                                    {
                                        path: "/AdminCuadre/:cuaId",
                                        navbarName: "cuadre",
                                        component: CuadreDetalle
                                    },
                                    {
                                        path: "/AdminCuadre/info",
                                        navbarName: "cuadre",
                                        component: CuadreInfo
                                    },
                                ]
                            },
                            {
                                path: "/UsosMultiples",
                                sidebarName: "usosMultiples",
                                navbarName: "usosMultiples",
                                component: UsosMultiples
                            },
                            {
                                path: "/Enums",
                                sidebarName: "enums",
                                navbarName: "enums",
                                component: Enums
                            },
                            {
                                path: "/Paises",
                                sidebarName: "paises",
                                navbarName: "paises",
                                component: Paises
                            },
                        ]
                    }]:[]
            ),
            { redirect: true, path: "/", to: "/inicio", navbarName: "Redirect" }
        ]
    )
    return obj
}
export default getRoutes;
